// extracted by mini-css-extract-plugin
export default {"tax":"tax_tax__1G-28"};